import { TagAttachment } from '@rtls/core/models/tag/tag-attachment';
import { nullable, randomDate } from '@rtls/map/util/factory/factory.util';
import * as Factory from 'factory.ts/lib';

export const tagAttachmentFactory = Factory.makeFactory<TagAttachment>({
	id: Factory.each((i) => nullable(i)),
	createdDate: Factory.each(() => nullable(randomDate())),
	dateAttached: Factory.each(() => nullable(randomDate())),
	dateEnabled: Factory.each(() => nullable(randomDate())),
	// tag?: Tag
});
